import { render, staticRenderFns } from "./MmfEntityForm.vue?vue&type=template&id=d33225b8&"
import script from "./MmfEntityForm.vue?vue&type=script&lang=js&"
export * from "./MmfEntityForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports